export default __webpack_public_path__ + "static/media/phone.dcdfe7ee.svg";